import { loadArrow, op, desc } from "arquero";

export const useGSOD = (
  locationId: string,
  monthNo = null,
  startYear = null,
  endYear = null
) => {
  console.log("useGSOD", locationId, monthNo, startYear, endYear);
  const config = useRuntimeConfig();
    const rawData = ref(null);
  const dt = ref(null);
  const loaded = ref(false);
  const error = ref(false);
  const loadData = async () => {
    const url = `${config.public.GSOD_DATA_URL}${locationId}.arrow`;

    loadArrow(url)
      .then((d)  => {
          rawData.value = d
          .params({
            monthNo: monthNo,
            startYear: startYear,
            endYear: endYear,
          })
          .derive({
            year: (d: {obsDate: string}) => op.substring(d.obsDate, 0, 4),
            month: (d: {obsDate: string}) => op.parse_int(op.substring(d.obsDate, 5, 7), 10),
            day: (d: { obsDate: string; }) => op.parse_int(op.substring(d.obsDate,8,10),10),
            date: (d: { obsDate: string; }) =>
              op.utcdatetime(
                op.substring(d.obsDate, 0, 4),
                op.substring(d.obsDate, 5, 7) - 1,
                op.substring(d.obsDate, 8, 10),
                0,
                0,
                0
              ),
              decade: (d: {obsDate: string}) => { return op.substring(d.obsDate, 0, 3) + '0'},
            dayTempAbove100F: (d: {maxTemp: number;}) => {
              return d.maxTemp >= 100 ? 1 : 0;
            },
            dayTempDropsBelowFreezing: (d: {minTemp: number;}) => {
              return d.minTemp <= 32 ? 1 : 0;
            },
            dayTempNeverAboveFreezing: (d: {maxTemp: number}) => {
              return d.maxTemp <= 32 ? 1 : 0;
            },
            totalPrecipitation: (d: {totalPrecipitation: string}) => {
              return op.parse_float(d.totalPrecipitation) || 0;
            },
          })

          dt.value = rawData.value.filter((d: { month: number; year: number}, $: {monthNo: number, startYear: number, endYear: number}) => {
              return (($.monthNo === null || $.monthNo === d.month)
                  && ($.startYear === null || d.year >= $.startYear)
                  && ($.endYear === null || d.year <= $.endYear));
          });


          loaded.value = true;
      })
      .catch((e) => {
        console.error(e);
        error.value = true;
        return;
      });
  };

  loadData().catch((e) => {
    console.error(e);
    error.value = true;
  });

  const summary = computed(() => {
    return summaryByMonthYear.value
      .groupby("year")
      .rollup({
        minTemp: (d) => op.min(d.minMinTemp),
        meanMinTemp: (d) => op.mean(d.meanMinTemp),
        maxTemp: (d) => op.max(d.maxMaxTemp),
        meanMaxTemp: (d) => op.mean(d.meanMaxTemp),
        totalPrecipitation: (d) => op.sum(d.totalPrecipitation),
        daysBelowFreezing: (d) => op.sum(d.daysBelowFreezing),
        daysAbove100F: (d) => op.sum(d.daysAbove100F),
        daysNeverAboveFreezing: (d) => op.sum(d.daysNeverAboveFreezing),
      })
      .rollup({
        minMinTemp: (d) => op.min(d.minTemp),
        meanMinTemp: (d) => op.mean(d.meanMinTemp),
        maxMaxTemp: (d) => op.max(d.maxTemp),
        meanMaxTemp: (d) => op.mean(d.meanMaxTemp),
        meanTotalPrecipitation: (d) => op.mean(d.totalPrecipitation),
        meanDaysBelowFreezing: (d) => op.mean(d.daysBelowFreezing),
        meanDaysAbove100F: (d) => op.mean(d.daysAbove100F),
        meanDaysNeverAboveFreezing: (d) => op.mean(d.daysNeverAboveFreezing),
      })
      .object();
  });

  const summaryByDecade = computed(() => {
      return summaryByYear.value
          .groupby('decade')
          .rollup({
              meanMinTemp: (d: {meanMinTemp: number}) => op.mean(d.meanMinTemp),
              meanMaxTemp: (d: {meanMaxTemp: number}) => op.mean(d.meanMaxTemp),
              daysBelowFreezing: (d: {daysBelowFreezing: number}) => op.mean(d.daysBelowFreezing),
              daysNeverAboveFreezing: (d: {daysNeverAboveFreezing: number}) => op.mean(d.daysNeverAboveFreezing),
              daysAbove100F: (d: {daysAbove100F: number}) => op.mean(d.daysAbove100F)
          })
          .objects()
  })
  /*
   * Monthly/Yearly Averages
   * For the available data calculate the averages by month and year
   */
  const summaryByMonthYear = computed(() => {
    return dt.value
      .groupby("year", "month")
      .rollup({
        meanMinTemp: (d) => op.round(op.mean(d.minTemp)),
        minMinTemp: (d) => op.min(d.minTemp),
        meanMaxTemp: (d) => op.round(op.mean(d.maxTemp)),
        maxMaxTemp: (d) => op.max(d.maxTemp),
        totalPrecipitation: (d) => op.sum(d.totalPrecipitation),
          daysPrecipitation: (d) => op.sum(d.totalPrecipitation > 0 ? 1 : 0),
        daysBelowFreezing: (d) => op.sum(d.dayTempDropsBelowFreezing),
        daysAbove100F: (d) => op.sum(d.dayTempAbove100F),
        daysNeverAboveFreezing: (d) => op.sum(d.dayTempNeverAboveFreezing),
      })
      .derive({ date: (d) => op.utcdatetime(d.year, d.month - 1, 1, 0, 0, 0) })
      .orderby("year", "month");
  });

  /*
  * For each year calculate the averages
   */
    const summaryByYear = computed(() => {
        const data = dt.value
            .groupby("year")
            .rollup({
                decade: (d: {decade: string}) => op.max(d.decade),
                maxMaxTemp: (d: {maxTemp: number}) => op.max(d.maxTemp),
                meanMaxTemp: (d: {maxTemp: number}) => op.mean(d.maxTemp),
                minMaxTemp: (d: {maxTemp: number}) => op.min(d.maxTemp),
                meanMinTemp: (d: {minTemp: number}) => op.mean(d.minTemp),
                minMinTemp: (d: {minTemp: number}) => op.min(d.minTemp),
                maxMinTemp: (d: {minTemp: number}) => op.max(d.minTemp),
                month: (d: {month: number}) => op.max(d.month),
                daysBelowFreezing: (d: {dayTempDropsBelowFreezing: number}) => op.sum(d.dayTempDropsBelowFreezing),
                daysAbove100F: (d: {dayTempAbove100F: number}) => op.sum(d.dayTempAbove100F),
                daysNeverAboveFreezing: (d: { dayTempNeverAboveFreezing: number}) => op.sum(d.dayTempNeverAboveFreezing)
            })
            .derive({
                tempRange: (d) => [op.round(d.meanMinTemp), op.round(d.meanMaxTemp)],
                maxTempRange: (d) => [op.round(d.minMaxTemp), op.round(d.maxMaxTemp)],
                minTempRange: (d) => [op.round(d.minMinTemp), op.round(d.maxMinTemp)],
                date: (d) => op.utcdatetime(d.year, d.month - 1 , 1, 0, 0, 0),
            })
            .orderby("year");

        return data
    })
  /*
  * For each day calculate the averages
   */
  const summaryByDay = computed(() => {
    const data = dt.value
        .groupby("day")
        .rollup({
          maxMaxTemp: (d) => op.max(d.maxTemp),
          meanMaxTemp: (d) => op.mean(d.maxTemp),
          minMaxTemp: (d) => op.min(d.maxTemp),
          meanMinTemp: (d) => op.mean(d.minTemp),
          minMinTemp: (d) => op.min(d.minTemp),
          maxMinTemp: (d) => op.max(d.minTemp),
          month: (d) => op.max(d.month),
        })
        .derive({
          tempRange: (d) => [op.round(d.meanMinTemp), op.round(d.meanMaxTemp)],
          maxTempRange: (d) => [op.round(d.minMaxTemp), op.round(d.maxMaxTemp)],
          minTempRange: (d) => [op.round(d.minMinTemp), op.round(d.maxMinTemp)],
          date: (d) => op.utcdatetime(2020, d.month - 1 , d.day, 0, 0, 0),
        })
        .orderby("day");

    return data
  })
  /*
    Monthly Averages
    * For the available data calculate the averages by month
     */
  const summaryByMonth = computed(() => {
    return summaryByMonthYear.value
      .groupby("month")
      .rollup({
        meanMinTemp: (d) => op.mean(d.meanMinTemp),
        minMinTemp: (d) => op.min(d.minMinTemp),
        meanMaxTemp: (d) => op.mean(d.maxMaxTemp),
        maxMaxTemp: (d) => op.max(d.maxMaxTemp),
        meanTotalPrecipitation: (d) => op.mean(d.totalPrecipitation),
        meanDaysPrecipitation: (d) => op.mean(d.daysPrecipitation),
      })
      .derive({ date: (d) => op.utcdatetime(2022, d.month - 1, 1, 0, 0, 0) })
      .orderby("month");
  });
  /*
   * Annual Average Snow Days
   * For the available data, calculate the average number of days per year with snow
   * and then calculate the average of those averages.
   */
  const snowDaysAnnually = computed(() => {
    const data = dt.value
      .groupby("year")
      .rollup({ snowDays: (d) => op.sum(d.snowIndicator) })
      .rollup({ snowDays: (d) => op.mean(d.snowDays) });
    return data.object().snowDays;
  });

  /*
   * Annual Average Monthly Snow Days
   * For the available data, calculate the average number of days per month with snow
   */
  const snowDaysByMonth = computed(() => {
    return dt.value
      .groupby("year", "month")
      .rollup({ snowDays: (d) => op.sum(d.snowIndicator) })
      .groupby("month")
      .rollup({ snowDays: (d) => op.mean(d.snowDays) });
  });

  /*
   * Number of Snow Days By Year
   * For the available data, calculate the number of days per year with snow
   */
  const snowDaysByYear = computed(() => {
    const data = dt.value
      .groupby("year")
      .rollup({ snowDays: (d) => op.sum(d.snowIndicator) });
    return data.objects();
  });

  /*
   * Top 5 months with the most days of snow
   * For the available data, calculate the top 5 months with the most days when it snows
   */
  const snowDaysRecordsByMonth = computed(() => {
    return dt.value
      .groupby("year", "month")
      .rollup({ snowDays: (d) => op.sum(d.snowIndicator) })
      .orderby(desc("snowDays"))
      .slice(0, 5)
      .derive({ date: (d) => op.utcdatetime(d.year, d.month - 1, 1, 0, 0, 0) });
  });
  /*
   * Top 5 days with the most snow
   * For the available data, calculate the top 5 days with the greatest snow depth
   */
  const snowDepthRecordsByDate = computed(() => {
    return dt.value
      .filter((d) => d.snowDepth !== null)
      .orderby(desc("snowDepth"))
      .slice(0, 5)
      .select("date", "snowDepth");
  });

  /*
   * Top 5 months with the most snow
   * For the available data, calculate the top 5 months with the most snow
   */
  const snowDepthRecordsByMonth = computed(() => {
    return dt.value
      .filter((d) => d.snowDepth !== null)
      .groupby("year", "month")
      .rollup({ snowDepth: (d) => op.round(op.mean(d.snowDepth)) })
      .orderby(desc("snowDepth"))
      .slice(0, 5)
      .derive({ date: (d) => op.utcdatetime(d.year, d.month, 1, 0, 0, 0) })
      .select("date", "snowDepth");
  });

  const recordsWarmestDays = computed(() => {
    return dt.value
      .orderby(desc("maxTemp"))
      .slice(0, 5)
      .select("date", "maxTemp");
  });

  const recordsWarmestMonths = computed(() => {
    return dt.value
      .groupby("year", "month")
      .rollup({ maxTemp: (d) => op.round(op.mean(d.maxTemp)) })
      .orderby(desc("maxTemp"))
      .slice(0, 5)
      .derive({ date: (d) => op.utcdatetime(d.year, d.month - 1, 1, 0, 0, 0) })
      .select("date", "maxTemp");
  });

  const recordsColdestMonths = computed(() => {
    return dt.value
      .groupby("year", "month")
      .rollup({ minTemp: (d) => op.round(op.mean(d.minTemp)) })
      .orderby("minTemp")
      .slice(0, 5)
      .derive({ date: (d) => op.utcdatetime(d.year, d.month - 1, 1, 0, 0, 0) })
      .select("date", "minTemp");
  });

  const recordsColdestDays = computed(() => {
    return dt.value
      .filter((d) => d.minTemp !== null)
      .orderby("minTemp")
      .slice(0, 5)
      .select("date", "minTemp");
  });

  const observationDates = computed(() => {
    const r = rawData.value
      .rollup({
        from: op.min("date"),
        to: op.max("date"),
      })
      .object();

    return r
  });

  const recordsWettestDays = computed(() => {
    return dt.value
      .orderby(desc("totalPrecipitation"))
      .slice(0, 5)
      .select("date", "totalPrecipitation");
  });

  const recordsWettestMonths = computed(() => {
    return dt.value
      .groupby("year", "month")
      .rollup({
        totalPrecipitation: (d) =>
          op.round(op.sum(d.totalPrecipitation) * 100) / 100,
      })
      .orderby(desc("totalPrecipitation"))
      .slice(0, 5)
      .derive({ date: (d) => op.utcdatetime(d.year, d.month - 1, 1, 0, 0, 0) })
      .select("date", "totalPrecipitation");
  });

  const recordsDriestMonths = computed(() => {
    return dt.value
      .filter((d) => d.totalPrecipitation !== null)
      .groupby("year", "month")
      .rollup({
        totalPrecipitation: (d) =>
          op.round(op.sum(d.totalPrecipitation) * 100) / 100,
      })
      .orderby("totalPrecipitation")
      .slice(0, 5)
      .derive({ date: (d) => op.utcdatetime(d.year, d.month, 1, 0, 0, 0) })
      .select("date", "totalPrecipitation");
  });

  return {
    recordsWarmestDays,
    recordsColdestDays,
    recordsWarmestMonths,
    recordsColdestMonths,
    recordsWettestDays,
    recordsWettestMonths,
    recordsDriestMonths,
    snowDaysAnnually,
    snowDaysByMonth,
    snowDaysByYear,
    snowDaysRecordsByMonth,
    snowDepthRecordsByDate,
    snowDepthRecordsByMonth,
    summary,
      summaryByYear,
    summaryByMonth,
    summaryByDay,
      summaryByDecade,
    error,
    loaded,
    locationId,
    monthNo,
    startYear,
    observationDates,
    endYear,
  };
};
